export default function toggleObjectFilters() {
  function init() {
    const toggleBuildingFilters = document.querySelectorAll(
      ".toggle-building-filter"
    );
    const buildingFilterWindow = document.querySelector(
      ".building-filter-window"
    );
    const closeBuildingFilters = document.querySelectorAll(
      ".close-building-filter"
    );
    const buildingFilterOptions = document.querySelectorAll(".svg-building");

    const toggleObjectFilter = document.querySelector(".toggle-object-filter");
    const objectFilterWindow = document.querySelector(".object-filter-window");
    const closeObjectFilter = document.querySelector(".close-object-filter");

    const closeMobileObjectFilters = document.querySelectorAll(
      ".close-object-filter-mob"
    );

    // ------------------------- //

    function open(e) {
      e.classList.add("opacity-fade-in");
      e.classList.remove("hidden");

      setTimeout(function () {
        e.classList.remove("opacity-fade-in");
      }, 300);
    }

    function close(e) {
      e.classList.add("opacity-fade-out");

      setTimeout(function () {
        e.classList.add("hidden");
        e.classList.remove("opacity-fade-out");
      }, 300);
    }

    // ------------------------- //

    toggleBuildingFilters.forEach((filter) => {
      filter.addEventListener("click", function () {
        open(buildingFilterWindow);
      });
    });

    closeBuildingFilters.forEach((filter) => {
      filter.addEventListener("click", function () {
        close(buildingFilterWindow);
      });
    });

    buildingFilterOptions.forEach((option) => {
      option.addEventListener("click", function () {
        close(buildingFilterWindow);
      });
    });

    // ------------------------- //

    toggleObjectFilter.addEventListener("click", function () {
      open(objectFilterWindow);
      toggleObjectFilter.classList.add("hidden");
      closeObjectFilter.classList.remove("hidden");
    });

    closeObjectFilter.addEventListener("click", function () {
      close(objectFilterWindow);
      toggleObjectFilter.classList.remove("hidden");
      closeObjectFilter.classList.add("hidden");
    });

    closeMobileObjectFilters.forEach((closeBtn) => {
      closeBtn.addEventListener("click", function () {
        close(objectFilterWindow);
        toggleObjectFilter.classList.remove("hidden");
        closeObjectFilter.classList.add("hidden");
      });
    });
  }

  const isPresent = document.getElementsByClassName("toggle-object-filter");
  if (isPresent.length > 0) {
    init();
  }
}
